import React from 'react'
import { Helmet } from 'react-helmet-async'

interface PageTitleProps {
  title: string
}

const PageTitle: React.SFC<PageTitleProps> = ({ title }) => (
  <Helmet>
    <title>{`${title} | Curated.com`}</title>
    <meta property="og:title" content={`${title} | Curated.com`} />
  </Helmet>
)

export default PageTitle
